import XTbl,{Xtc} from '../../components/x-table/index';
const tbl = new XTbl('billing/official-receipt/query/', 'bill-receipt');

tbl.add(new Xtc('receipt_no', 'Receipt no').noSort().renderSlot('receipt_no'))
tbl.add(new Xtc('payment_type', 'Payment Type').noSort().renderSlot('payment_type'))
tbl.add(new Xtc('remark', 'Remark').noSort())
tbl.add(new Xtc('amount', 'Amount').noSort().renderSlot('amount'))
tbl.add(new Xtc('bank_in_date', 'Bank in Date').noSort().renderSlot('bank_date'))
tbl.add(new Xtc('date', 'Date').noSort().renderSlot('date'))
tbl.add(new Xtc('factor_no', 'Payment For').noSort().renderSlot('factor_no'))
tbl.add(new Xtc('receive_from', 'Receive From').noSort().renderSlot('receive_from'))
tbl.add(new Xtc('action', 'Actions').noSort().renderSlot('action'))

export default tbl;

